interface Props {
    errors?: readonly string[];
}

export const InputErrors = ({ errors = [] }: Props) => {
    const errorComps = errors.map((error) => (
        <div key={error.replace(/\s/g, '-').toLowerCase()} className="input__sub-text__error">
            {error}
        </div>
    ));

    return errors.length > 0 ? (
        // biome-ignore lint/a11y/useSemanticElements: biome wants some other element type for alert
        <div data-testid="search-form-errors" className="input__sub-text u-size1of1" role="alert" aria-atomic="false">
            {errorComps}
        </div>
    ) : null;
};
